import { ApiResult } from 'interfaces/APITypes';
import { ChangeEmailFormData, ChangePasswordFormData } from 'interfaces/FormData';
import { Locale } from 'interfaces/Locale';
import { UpdateAccountData } from 'interfaces/user/Account';
import { User } from 'interfaces/user/User';

import { makeRequest, mytoverInstance } from './client';

export const getAccountInfo = async (): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get('/account'));
};

export const updateAccount = async (account: UpdateAccountData): Promise<ApiResult<User>> => {
  return makeRequest(mytoverInstance.patch('/account', account));
};

export const deleteAccount = async (): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.delete('/account'));
};

export const recoverAccount = async (token: string): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.post(`/account/recover/${token}`));
};

export const updateEmail = async (values: ChangeEmailFormData): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.patch('/account/email', values));
};

export const recoverEmail = async (token: string): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.post(`/account/email/recover/${token}`));
};

export const verifyEmail = async (token: string): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.post(`/account/email/verify/${token}`));
};

export const updatePassword = async (values: ChangePasswordFormData): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.post('/account/change-password', values));
};

export const getProfileImages = async (): Promise<ApiResult<{ data: any[] }>> => {
  return makeRequest(mytoverInstance.get('/account/profile-images'));
};

export const setLocale = async (locale: Locale): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.post('/account/locale', { code: locale.code }));
};
